module.exports = __webpack_public_path__ + "web/img/speech3.baa2bbb7.png";